import React from 'react';

import {Radio} from 'antd';
import type {CheckboxOptionType} from 'antd/lib/checkbox/Group';
import {lighten} from 'polished';
import styled from 'styled-components';

import {colors} from 'lib/colors';

const RadioGroup = Radio.Group;

const Label = styled.span`
  display: block;
  font-weight: 500;
  font-size: 1.1em;
  margin-bottom: 2px;
`;
const Description = styled.span`
  display: block;
  margin-bottom: 2px;
`;
const RadioOption = styled(Radio)`
  &&[class$='wrapper-checked'] {
    border: 1px solid ${lighten(0.3, colors.primary)};
    background-color: ${lighten(0.59, colors.primary)};
  }
  &&:last-child {
    margin-right: 0;
  }
  && {
    flex: 1;
    white-space: normal;
    display: flex;
    align-items: flex-start;
    border-radius: 2px;
    border: 1px solid #e8e8e8;
    background-color: #fff;
    transition: all 0.3s;
    padding: 10px 16px;
    zoom: 1;
  }
  .ant-radio {
    margin-top: 5px;
  }
`;

// eslint-disable-next-line react-refresh/only-export-components
export const ChoicesGroup = styled(RadioGroup)`
  && {
    display: flex;
    margin-bottom: 20px;
  }
`;

interface ChoiceProps extends CheckboxOptionType {
  children?: React.ReactNode;
}

export const Choice: React.FC<ChoiceProps> = ({label, children, ...props}) => (
  <RadioOption {...props}>
    <Label>{label}</Label>
    {children && <Description>{children}</Description>}
  </RadioOption>
);
